import LogRocket from "logrocket";

export function identify(userId, customProps) {
  LogRocket.identify(userId, customProps);
}